module.exports = __webpack_public_path__ + "static/flags/AM-7f276f8fbefa6569dc68a184fd439283.gif";